// extracted by mini-css-extract-plugin
export default {"languageDot":"LanguageDot-module__languageDot--h8s9C"};